'use client';
import { useContext } from 'react';
import { TabContext } from './TabContext';

export interface TabContentProps {
  children?: React.ReactNode;
  title: string;
}

export const TabContent = ({ children, title }: TabContentProps) => {
  const { activeTab } = useContext(TabContext);
  if (activeTab.title !== title) return null;
  if (!children) return null;
  return <div>{children}</div>;
};

export default TabContent;
